module.exports = __webpack_public_path__ + "media/images/square-785067f154fa58eebf222621db2e92c8.png";